// Helper function to check if an item is unshippable
export const isItemUnshippable = (item, unshippableItems) => {
  const itemId = item.id || item.cartItemIndex;
  const method = item.deliveryMethod || 'shipping';
  
  // Check in the new structure
  if (typeof unshippableItems === 'object' && !Array.isArray(unshippableItems)) {
    // If unshippableItems is the new object structure
    if (unshippableItems[method]) {
      // Check all address groups for this method
      for (const addressId in unshippableItems[method]) {
        if (Array.isArray(unshippableItems[method][addressId]) && 
            unshippableItems[method][addressId].includes(itemId)) {
          return true;
        }
      }
    }
    
    // Also check legacy array for backward compatibility
    if (unshippableItems.legacy && Array.isArray(unshippableItems.legacy)) {
      if (unshippableItems.legacy.includes(itemId)) { // ensure it's an array before .includes
        return true;
      }
    }
    
    return false;
  }
  
  // Fallback to legacy behavior if unshippableItems is still an array
  return Array.isArray(unshippableItems) && unshippableItems.includes(itemId);
}; 